import { AxiosInstance } from 'axios';

export interface ISendChatCESData {
  hash: string;
  score: number;
  comment?: string;
  organization_id?: string;
}

type TSendChatCESResponse = {
  ok: boolean;
};

export default (supportBackendApi: AxiosInstance) => ({
  sendChatCES: (chatId: number, data: ISendChatCESData): Promise<TSendChatCESResponse> =>
    supportBackendApi.post(`ces/chat/${chatId}`, data),
});
